import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHelpFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25C6.61527 2.25 2.25 6.6053 2.25 12C2.25 17.3847 6.6053 21.75 12 21.75C17.3852 21.75 21.75 17.3852 21.75 12C21.75 6.61479 17.3852 2.25 12 2.25ZM11.99 7.07999C10.4658 7.07999 9.24001 8.30577 9.24001 9.82999C9.24001 10.2442 9.57579 10.58 9.99001 10.58C10.4042 10.58 10.74 10.2442 10.74 9.82999C10.74 9.1342 11.2942 8.57999 11.99 8.57999C12.6782 8.57999 13.24 9.13664 13.24 9.82999C13.24 10.2367 13.0327 10.4707 12.5878 10.78C12.0255 11.1558 11.25 11.7913 11.25 13V13.25C11.25 13.6642 11.5858 14 12 14C12.4142 14 12.75 13.6642 12.75 13.25V13C12.75 12.573 12.9689 12.3288 13.426 12.024L13.4261 12.0241L13.4376 12.0162C13.969 11.6474 14.74 11.0216 14.74 9.82999C14.74 8.30333 13.5018 7.07999 11.99 7.07999ZM11.999 15.25L11.9939 15.25L11.989 15.25C11.9682 15.25 11.9475 15.2508 11.9271 15.2525C11.4067 15.2891 10.999 15.72 10.999 16.25C10.999 16.7747 11.4256 17.25 11.999 17.25C12.2941 17.25 12.5399 17.1172 12.7031 16.9541C12.8663 16.7909 12.999 16.5451 12.999 16.25C12.999 15.6901 12.5566 15.2947 12.0725 15.2535C12.0483 15.2512 12.0238 15.25 11.999 15.25Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgHelpFilled);
export default ForwardRef;
